<ion-col class="radio-group-container ion-no-padding" size="6" toggleButtons>
  <p class="heading-label" [ngClass]="{ 'has-padding': hasPadding }">
    {{ header }}
  </p>
  <div class="form" [ngClass]="{ 'has-padding': hasPadding }">
    <div class="form-group">
      <input
        type="radio"
        class="form-control"
        [name]="firstOptionValue"
        [id]="firstOptionValue"
        [value]="firstOptionValue"
        [disabled]="isDisabled"
        [(ngModel)]="radioModel"
        (change)="valueChange($event)"
        checked
      />
      <label [for]="firstOptionValue" class="form-label">
        {{ firstOptionName }}
      </label>
    </div>
    <div class="form-group">
      <input
        type="radio"
        class="form-control"
        [name]="secondOptionValue"
        [id]="secondOptionValue"
        [value]="secondOptionValue"
        [disabled]="isDisabled"
        [(ngModel)]="radioModel"
        (change)="valueChange($event)"
      />
      <label [for]="secondOptionValue" class="form-label">
        {{ secondOptionName }}
      </label>
    </div>
  </div>
</ion-col>
